import { assertNever } from "@decibeltrade/utils";
import { ReactNode } from "react";
import { css, cx } from "styled-system/css";
import { center } from "styled-system/patterns";

import { Spinner, type SpinnerProps } from "../spinner";
import { ButtonProps } from "./button";

export interface ButtonContentWithSpinnerProps extends Pick<
  ButtonProps,
  "loading" | "size" | "variant"
> {
  children: ReactNode;
  className?: string;
}

export function ButtonContentWithSpinner({
  children,
  loading,
  size,
  variant,
  className,
}: ButtonContentWithSpinnerProps) {
  return (
    <>
      <div
        className={cx(center({ visibility: loading ? "hidden" : "visible", h: "full" }), className)}
      >
        {children}
      </div>
      {loading && (
        <div
          className={css({
            position: "absolute",
            top: "[50%]",
            left: "[50%]",
            transform: "translate(-50%, -50%)",
          })}
        >
          <Spinner
            size={size === "lg" ? "md" : "sm"}
            variant={buttonVariantToSpinnerVariant(variant)}
          />
        </div>
      )}
    </>
  );
}

function buttonVariantToSpinnerVariant(variant: ButtonProps["variant"]): SpinnerProps["variant"] {
  switch (variant) {
    case "primary":
      return "onPrimary";
    case "secondary":
      return "secondary";
    case "destructive":
      return "onPrimary";
    case "brand":
      return "onPrimary";
    case "text":
      return "secondary";
    case "buy":
      return "onPrimary";
    case "sell":
      return "onPrimary";
    case undefined:
      return "onPrimary";
    default:
      assertNever(variant, "Unknown button variant received");
  }
}
